import React from "react";
import pageLogo from "../../../assets/images/png/footer-logo.jpeg";
import Icons from "./Icons";
import Paragraph from "../ui/Paragraph";
import { FOOTER_DATA_LIST, FOOTER_DATA_LIST2 } from "../../../utils/defaults";
import ContactUs from "./ContactUs";
import { Link, useLocation } from "react-router-dom";
import footerBg from "../../../assets/images/webp/footer-bg.webp";
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const path = useLocation().pathname;
  const updatedArr =
    path === "/india-invention" ? FOOTER_DATA_LIST2 : FOOTER_DATA_LIST;
  return (
    <div
      style={{ backgroundImage: `url(${footerBg})` }}
      className="bg-cover bg-no-repeat bg-center relative lg:pb-5"
    >
      <ContactUs className="absolute left-1/2 -translate-x-1/2 w-full -top-[35%] container 2xl:px-0 max-lg:-top-[19%]" />
      <div className="container mx-auto pb-12 pt-[231px] px-4 xl:px-0 max-lg:pt-[275px]">
        <div className="flex w-full max-2xl:max-w-[1140px] justify-between max-xl:gap-9 max-md:flex-wrap mx-auto">
          <div className="md:max-w-[177px] lg:max-w-[318px]">
            <Link to="/">
              <img
                src={pageLogo}
                className="w-[100px] md:w-[150px] "
                alt="Footer Logo"
              />
            </Link>
            <Paragraph variant="white" className="pt-6">
              Makeway India started its journey with the vision to revolutionize
              industries and bring innovative solutions to life. Over the years,
              we’ve expanded our reach, embracing emerging challenges and
              turning them into opportunities for growth.
            </Paragraph>
          </div>
          <div className="max-2xl:max-w-[682px] max-w-[768px] flex justify-between w-full gap-5 max-lg:max-w-[455px] max-md:max-w-none max-sm:flex-wrap max-sm:gap-y-9">
            {updatedArr.map((obj, i) => (
              <div key={i}>
                <p className="font-semibold text-base leading-150 text-white whitespace-nowrap pb-4">
                  {obj.title}
                </p>
                <div className={`flex w-full flex-col`}>
                  {obj.list.map((val, idx) => (
                    <div
                      key={idx}
                      className={`flex items-start ${
                        idx === 2
                          ? "max-w-[289px] pt-3"
                          : idx === 0
                          ? ""
                          : "pt-3"
                      }`}
                    >
                      <span className="">
                        <Icons icon={val.icon} className="mr-3" />
                      </span>
                      <Link
                        onClick={scrollToTop}
                        to={val.url}
                        className="text-custom-white-v4 hover:opacity-80 leading-150 max-lg:text-sm"
                      >
                        {val.subTitle}
                        {val.subTitle2 && (
                          <p className="mt-3">{val.subTitle2}</p>
                        )}
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <Icons />
          </div>
        </div>
      </div>

      <div
        className="w-full h-px z-50"
        style={{
          background:
            "linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff 50.78%, hsla(0, 0%, 100%, 0))",
        }}
      ></div>
      <div className="max-w-[288px] px-4 pt-6 pb-[18px] max-lg:py-5 mx-auto flex sm:justify-between flex-col gap-2 sm:flex-row items-center">
        <Paragraph variant="white" className="whitespace-nowrap leading-120">
          © Copyright {new Date().getFullYear()}, All Rights Reserved
        </Paragraph>
      </div>
    </div>
  );
};
export default Footer;
